export const isCookieTrue = (cookieName) => {
  const cookies = document.cookie.split(';');

  return cookies
    .map((cookie) => cookie.trim().split('='))
    .some(([name, value]) => name === cookieName && value === 'true');
};
